import { render, staticRenderFns } from "./GetCustomerDispatchByNumber.vue?vue&type=template&id=51709548&scoped=true&"
import script from "./GetCustomerDispatchByNumber.vue?vue&type=script&lang=js&"
export * from "./GetCustomerDispatchByNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51709548",
  null
  
)

export default component.exports